import React from 'react';
import styled from 'styled-components';

const Svg = styled.svg``;

const BackgroundCircle = styled.circle`
    ${Svg}:hover & {
        fill: #f5f5f5;
    }
`;

const EditIcon = () => (
    <Svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <BackgroundCircle cx="20" cy="20" r="15" />
        <path d="M25 19L21 15" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M17.5 26.5L12.5 27.5L13.5 22.5L23.5 12.5L27.5 16.5L17.5 26.5Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
);

export default EditIcon;
